var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWhatsAppSquare = function SvgIconWhatsAppSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.946 7.775a8.192 8.192 0 0 0-6.882 12.582.74.74 0 0 1 .094.588L8.55 23.16a.3.3 0 0 0 .366.37l2.304-.609a.74.74 0 0 1 .563.085 8.192 8.192 0 1 0 4.163-15.231m4.81 11.71a2.49 2.49 0 0 1-1.653 1.17 3.24 3.24 0 0 1-1.554-.1 14 14 0 0 1-1.405-.51 11.05 11.05 0 0 1-4.214-3.73 4.85 4.85 0 0 1-.957-2.536 2.79 2.79 0 0 1 .87-2.063.92.92 0 0 1 .659-.298h.472c.15 0 .348 0 .547.422.2.423.696 1.716.759 1.828a.45.45 0 0 1 0 .435 1.7 1.7 0 0 1-.249.41c-.124.15-.261.323-.373.435s-.249.261-.1.497a7.2 7.2 0 0 0 1.368 1.716 6.9 6.9 0 0 0 1.977 1.243c.248.125.398.1.534 0q.418-.463.784-.97c.161-.248.323-.198.546-.124s1.443.684 1.691.808c.249.125.41.187.473.286.058.365.015.74-.125 1.082zm-4.81 6.341a9.95 9.95 0 0 1-4.712-1.243l-3.549.96a1 1 0 0 1-1.226-1.227l.933-3.425A9.858 9.858 0 0 1 22.957 9.006a9.76 9.76 0 0 1 2.934 6.961 9.87 9.87 0 0 1-9.945 9.859"
  })));
};
export default SvgIconWhatsAppSquare;